import React from 'react'
import { Hider } from '@components/HOCs/Hider'
import { NumberFieldWithLabel } from '@components/Form/Fields'
import { ASSET_ALLOCATION_FIELDS } from '../../utils/formFieldsForAssetType'
import { Grid } from '@components/layout/Grid'
import { humanizeString } from '@utils/stringMinipulation'
import { INTEREST_RATE_CONTROL } from './AssetFields'

export const AssetAllocationGroup = ({ values, errors }) => {
  return (
    <>
      <Hider withTransition collapse
        show={values.interestRateControl === INTEREST_RATE_CONTROL.BASED_ON_ASSET_ALLOCATION}
        render={() =>
          <AssetAllocationFields values={values} />}
      />
      <AssetAllocationError errors={errors} />
    </>
  )
}

const AssetAllocationFields = ({ values }) =>
  <Grid halfSplit>
    {ASSET_ALLOCATION_FIELDS.map((allocation) =>
      <NumberFieldWithLabel
        key={allocation}
        name={allocation}
        value={values[allocation]}
        label={humanizeString(allocation)}
        placeholder={0}
        precision={2}
      />
    )}
  </Grid>

const AssetAllocationError = ({ errors }) =>
  errors.allocationTotal ? <span className='app-form__field-error'>{errors.allocationTotal}</span> : null
